export const CANCEL_REASON_CODES = [
  'better_offer_current_bank',
  'better_offer_other_bank',
  'cancelled_due_to_inactivity',
  'customer_data_was_wrong',
  'duplicate_application',
  'fixed_interest_term',
  'in_need_of_bridge_loan',
  'insufficient_service',
  'opportunity_passed',
  'other_reason',
  'refuse_to_supply_documents',
  'slow_service',
  'too_close_to_planned_payout',
  'too_far_from_planned_payout',
  'wrong_bank',
  'unknown_reason',
] as const
